import styled from "styled-components";

export const AuthWrapper = styled.div`
   height:100%;
   width: 100%;
`